import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';
import { WavyLink } from "react-wavy-transitions";

import logo from '../Images/logo.png';
import logo_blanco from '../Images/footer.png';

import { useAuth } from '../Context/Context';


const Header = () => {
  const { direction, cambio } = useAuth();
    
  useEffect(() => {
    var elems = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elems);
    
    cambio();
  }, []);


    return (
      <Fragment>
        
        <nav id='header' className='header_blanco' style={{boxShadow:"none", height:"100px"}}>
          <div class="nav-wrapper">

            <a href="/" id='logo_header' class="brand-logo" style={{height:"100px", display:"flex", alignItems:"center"}}>
              <img src={logo} id="imagen_header_1" className='imagen_header' alt="Software Over"/>
              <img src={logo_blanco} id="imagen_header_2" className='imagen_header' alt="Software Over"  style={{display:"none"}}  />
            </a>
            <a href="#!" data-target="mobile-demo" class="sidenav-trigger" style={{color:"#BF1F60", float:"right"}}>
              <i class="material-icons">menu</i>
            </a>

            <ul class="right hide-on-med-and-down separacion menu">
              <li onClick={cambio}>
                <WavyLink direction={direction ? "up" : "down"} to="/" color={direction ? "#BF1F60" : "#2A79B0"}>
                  <p id='inicio' className='titulo-header2'>
                    Inicio
                  </p>
                </WavyLink>
              </li>
              <li onClick={cambio}>
                <WavyLink direction={direction ? "up" : "down"} to="/nosotros" color={direction ? "#BF1F60" : "#2A79B0"}>
                  <p id='nosotros' className='titulo-header2'>
                    Nosotros
                  </p>
                </WavyLink>
              </li>
              <li onClick={cambio}>
                <WavyLink direction={direction ? "up" : "down"} to="/servicios" color={direction ? "#BF1F60" : "#2A79B0"}>
                  <p id='servicios' className='titulo-header2'>
                    Servicios
                  </p>
                </WavyLink>
              </li>
              <li onClick={cambio}>
                <WavyLink direction={direction ? "up" : "down"} to="/portafolio" color={direction ? "#BF1F60" : "#2A79B0"}>
                  <p id='portafolio' className='titulo-header2'>
                    Portafolio
                  </p>
                </WavyLink>
              </li>
              <li onClick={cambio}>
                <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                  <p id='contacto' className='titulo-header2'>
                    Contacto
                  </p>
                </WavyLink>
              </li>
              <li onClick={cambio}>
                <div style={{marginLeft:"40px", marginTop:"10px"}}>
                  <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                    <p class="boton btn-header z-depth-4" style={{letterSpacing:"1px", margin:"0px"}}>
                      Cotiza tu proyecto
                    </p>
                  </WavyLink>
                </div>
              </li>
            </ul>

          </div>
        </nav>

        <ul class="sidenav" id="mobile-demo">
          <li><a className='titulo-header' href="/">Inicio</a></li>
          <li><a className='titulo-header' href="/nosotros">Nosotros</a></li>
          <li><a className='titulo-header' href="/servicios">Servicios</a></li>
          <li><a className='titulo-header' href="/portafolio">Portafolio</a></li>
          <li><a className='titulo-header' href="/contacto">Contacto</a></li>
          <li><a class="boton btn-header z-depth-4" href='/' style={{color:"#FFFFFF"}}>Cotiza tu proyecto</a></li>
        </ul>

      </Fragment>
    );
}

export default Header;
